import { useI18n } from "@/shared/composables/use-i18n";
import { setup, Vue } from "vue-class-component";
import { Emit } from "vue-property-decorator";

export class DeclinePopup extends Vue {
    i18n = setup(useI18n);
    @Emit("closePopup")
    closePopup() {
        this.$emit("close");
    }
    queryText = "";
    @Emit("confirm")
    confirm() {
        this.$emit("confirmDecline", this.queryText);
    }
}
